import { message } from 'antd';

import i18n from '@/content';
import { captureWarningForSentry } from './sentryAdapter';

const nameSpace = 'copyItemToClipboard';

const tryCopyToClipBoard = async (text: string | null | undefined, item: string): Promise<void> => {
    const value = text?.trim();
    if (!value) return;

    try {
        await navigator.clipboard.writeText(value);
        message.success({
            content: i18n.t(`${nameSpace}.success`, { item }),
            key: nameSpace,
        });
    } catch (error) {
        console.log('Navigator clipboard error:', error);
        captureWarningForSentry(error, 'utils.tryCopyToClipBoard');
        message.error(i18n.t(`${nameSpace}.error`));
    }
};

export default tryCopyToClipBoard;
